
import { Component, Input, OnInit } from '@angular/core';

import { CustomFormFieldSubmission } from '@core/objects/form';
import { File } from '@core/objects/file';

import { UrlService } from '@core/services/url/url.service';
@Component({
    selector: 'form-field-view-files-v1',
    templateUrl: './view-files-v1.component.html'
})
export class ViewFilesV1FieldComponent implements OnInit{
    @Input() fieldSubmission: CustomFormFieldSubmission;

    constructor(private urlSrv : UrlService){}

    ngOnInit(): void {
    }

    // For now on is to download only
    onFileClick(file: File) : void {
        if (file != null){
            // url to preview Artwork FILE
            window.location.href = this.urlSrv.build('/files/'+file.id);
        }
    }

    onActionDownloadClick(file: File) : void {
        if (file != null){
            window.location.href = this.urlSrv.build('/files/'+file.id);
        }

    }

}   